/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Available_Share_Codes_LabelInputs */

const en_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available share codes`)
};

const fr_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codes de partage disponibles`)
};

const de_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Freigabecodes`)
};

const it_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codici di condivisione disponibili`)
};

const ru_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступные коды акций`)
};

const es_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de acciones disponibles`)
};

const zh_cn2_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用的股票代码`)
};

const ja_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能な共有コード`)
};

const hi_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्ध शेयर कोड`)
};

const pt_pt2_team_share_available_share_codes_label = /** @type {(inputs: Team_Share_Available_Share_Codes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de compartilhamento disponíveis`)
};

/**
* | output |
* | --- |
* | "Available share codes" |
*
* @param {Team_Share_Available_Share_Codes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_available_share_codes_label = /** @type {((inputs?: Team_Share_Available_Share_Codes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Available_Share_Codes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_available_share_codes_label(inputs)
	if (locale === "de") return de_team_share_available_share_codes_label(inputs)
	if (locale === "it") return it_team_share_available_share_codes_label(inputs)
	if (locale === "ru") return ru_team_share_available_share_codes_label(inputs)
	if (locale === "es") return es_team_share_available_share_codes_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_available_share_codes_label(inputs)
	if (locale === "ja") return ja_team_share_available_share_codes_label(inputs)
	if (locale === "hi") return hi_team_share_available_share_codes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_available_share_codes_label(inputs)
	return en_team_share_available_share_codes_label(inputs)
});